import React, { useEffect, useState } from "react";
import { Card, Typography, Box } from "@mui/material";
import axios from "axios";

import {
    AppWidgetSummary,
    AppCurrentVisits,
} from "../sections/@dashboard/app";

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from "recharts";

export default function ZoneDashboard({ zonaId, width = 800, height = 600 }) {

    const [zone, setZone] = useState(null);
    const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

    const BASE_WIDTH = 800;
    const BASE_HEIGHT = 600;

    const scaleX = width / BASE_WIDTH;
    const scaleY = height / BASE_HEIGHT;
    const scale = Math.min(scaleX, scaleY);

    useEffect(() => {
        if (zonaId) getZone();
    }, [zonaId]);

    const getZone = async () => {
        try {
            const res = await axios.get(`${SERVER_URL}/api/zonas/${zonaId}`);
            setZone(res.data);
        } catch (err) {
            console.log("error");
        }
    };

    if (!zone) return null;

    return (
        <Box
            sx={{
                width,
                height,
                overflow: "hidden"
            }}
        >
            <Box
                sx={{
                    width: BASE_WIDTH,
                    height: BASE_HEIGHT,
                    transform: `scale(${scale})`,
                    transformOrigin: "top left"
                }}
            >
                <Card
                    sx={{
                        backgroundColor: "#002855",
                        color: "#fff",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >

                    <Typography sx={{ ml: 2, mt: 1, fontSize: '1rem', fontWeight: 600 }}>
                        Pregled zone
                    </Typography>

                    <Box
                        sx={{
                            p: 1,
                            flex: 1,
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                            height: "100%"
                        }}
                    >

                        {/* GORNJI DIO */}
                        <Box sx={{ height: "65%", display: "flex", gap: 1 }}>

                            {/* GRAF */}
                            <Box sx={{ flex: 1 }}>
                                <Card sx={{ backgroundColor: "#001B44", height: "100%" }}>
                                    <Box sx={{ p: 1, height: "100%", display: "flex", flexDirection: "column" }}>

                                        <Typography sx={{ fontSize: '0.8rem', mb: 1 }}>
                                            Potrošnja
                                        </Typography>

                                        <Box sx={{ flex: 1 }}>
                                            <ResponsiveContainer width="100%" height="100%">
                                                <LineChart data={[
                                                    { name: 'Jan', value: zone.januar },
                                                    { name: 'Feb', value: zone.februar },
                                                    { name: 'Mar', value: zone.mart },
                                                    { name: 'Apr', value: zone.april },
                                                    { name: 'Maj', value: zone.maj },
                                                    { name: 'Jun', value: zone.juni },
                                                    { name: 'Jul', value: zone.juli },
                                                    { name: 'Aug', value: zone.august },
                                                    { name: 'Sep', value: zone.septembar },
                                                    { name: 'Okt', value: zone.oktobar },
                                                    { name: 'Nov', value: zone.novembar },
                                                    { name: 'Dec', value: zone.decembar },
                                                ]}>
                                                    <CartesianGrid stroke="#444" strokeDasharray="3 3" />
                                                    <XAxis dataKey="name" stroke="#fff" />
                                                    <YAxis stroke="#fff" />
                                                    <Tooltip />
                                                    <Line type="monotone" dataKey="value" stroke="#ffeb3b" strokeWidth={2} />
                                                </LineChart>
                                            </ResponsiveContainer>
                                        </Box>

                                    </Box>
                                </Card>
                            </Box>

                            {/* WIDGETI */}
                            <Box
                                sx={{
                                    flex: 1,
                                    display: "grid",
                                    gridTemplateColumns: "repeat(3, 1fr)",
                                    gridTemplateRows: "repeat(2, 1fr)",
                                    gap: 1
                                }}
                            >
                                {[
                                    {
                                        title: "Ukupno",
                                        value: zone.numbertotal,
                                        sx: { bgcolor: '#E3F2FD', '& svg': { color: '#1565C0' } }
                                    },
                                    {
                                        title: "Uključeno",
                                        value: zone.numberaktivne,
                                        sx: { bgcolor: '#FFF3C4', '& svg': { color: '#E6A800' } }
                                    },
                                    {
                                        title: "Isključeno",
                                        value: zone.numberneaktivne,
                                        sx: { bgcolor: '#F5F5F5', '& svg': { color: '#757575' } }
                                    },
                                    {
                                        title: "Alarmi",
                                        value: zone.numberalarms,
                                        sx: { bgcolor: '#FFE0B2', '& svg': { color: '#E65100' } }
                                    },
                                    {
                                        title: "Lampe bez konekcije",
                                        value: zone.numberfailed,
                                        sx: { bgcolor: '#FFEBEE', '& svg': { color: '#C62828' } }
                                    },
                                    {
                                        title: "Lampe sa kvarom",
                                        value: zone.numberfailed,
                                        sx: { bgcolor: '#FFCDD2', '& svg': { color: '#B71C1C' } }
                                    },
                                ].map((w, i) => (
                                    <AppWidgetSummary
                                        key={i}
                                        title={w.title}
                                        total={w.value}
                                        sx={{
                                            p: 1,
                                            height: "100%",
                                            ...w.sx,
                                            '& .MuiTypography-root': {
                                                fontSize: '0.7rem'
                                            }
                                        }}
                                    />
                                ))}
                            </Box>

                        </Box>

                        {/* DONJI DIO */}
                        <Box
                            sx={{
                                height: "35%",
                                display: "grid",
                                gridTemplateColumns: "repeat(4, 1fr)",
                                gap: 1
                            }}
                        >

                            <AppCurrentVisits
                                title="Modeli lampi"
                                chartData={[
                                    { label: '45W', value: zone.number45w },
                                    { label: '60W', value: zone.number60w },
                                    { label: '90W', value: zone.number90w },
                                ]}
                                chartColors={['#FFF3C4', '#FFE082', '#FFB74D']}
                                chartHeight={160}
                                sx={{ bgcolor: '#EAF3FF' }}
                            />

                            <AppCurrentVisits
                                title="Status lampi"
                                chartData={[
                                    { label: 'Aktivni', value: zone.numberaktivne },
                                    { label: 'Neaktivni', value: zone.numberneaktivne },
                                ]}
                                chartColors={['#FFD54F', '#BDBDBD']}
                                chartHeight={160}
                                sx={{ bgcolor: '#EAF3FF' }}
                            />

                            <AppCurrentVisits
                                title="Ukupna potrošnja po mjesecima"
                                chartData={[
                                    { label: 'Jan', value: zone.januar },
                                    { label: 'Feb', value: zone.februar },
                                    { label: 'Mar', value: zone.mart },
                                ]}
                                chartColors={['#AEDFF7', '#C8E6C9', '#FFE0B2']}
                                chartHeight={160}
                                sx={{ bgcolor: '#EAF3FF' }}
                            />

                            <AppCurrentVisits
                                title="Status alarma u zadnjih 30 dana"
                                chartData={[
                                    { label: 'Riješeni', value: zone.numberaktivne },
                                    { label: 'Neriješeni', value: zone.numberalarms },
                                ]}
                                chartColors={['#A5D6A7', '#EF9A9A']}
                                chartHeight={160}
                                sx={{ bgcolor: '#EAF3FF' }}
                            />

                        </Box>

                    </Box>
                </Card>
            </Box>
        </Box>
    );
}
